const siteOverlay = document.getElementById('siteOverlay');


const overlayToggle = (show, callback, showClass = '_show') => {
  if (!siteOverlay) {
    return;
  }

  siteOverlay.classList.toggle(showClass, show);
  siteOverlay.addEventListener('click', e => {
    callback(e);
  }, { once: true });

  // Vue. Hate it.
  window.overlayToggleApp(show, callback, showClass);

  // typeof toggle !== 'undefined' ? 
  //   siteOverlay.classList.toggle('_show', toggle)
  // :
  //   siteOverlay.classList.toggle('_show')
  // ;
};

const overlayToggleMobile = (show, callback) => {
  overlayToggle(show, callback, '_show_mobile');
};

// const overlayAttachClick = (callback, options) => {
//   siteOverlay.addEventListener('click', e => {
//     callback();
//   }, options);
// }

window.overlayFunctions = {
  overlayToggle: overlayToggle,
  overlayToggleMobile: overlayToggleMobile,
  // overlayAttachClick: overlayAttachClick,
};

module.exports = window.overlayFunctions;